module.exports = __webpack_public_path__ + "static/img/LY.05e2811b.png";